/**
 * bodyMotionTiming — pure timing rules for the Generate Body Animation wizard's
 * Waypoints section (no React, no DOM, so they unit-test under `node --test`;
 * same split as optionFilter.js / bodyMotionPath.js).
 */

/**
 * The value the Duration field should hold when the author switches Timing to
 * "By duration".
 *
 * Entering duration mode pre-fills the field from the route-derived duration
 * (length ÷ avg speed, clampRouteDuration) so the pinned value starts somewhere
 * sensible — but ONLY while the author hasn't set a duration themselves.
 * Re-seeding on every click silently threw a hand-entered duration away
 * (duration → type 8 → speed → duration wiped the 8), which is the bug this
 * exists to prevent.
 *
 * @param {object} args
 * @param {string} args.current      the field's current text value
 * @param {number|null} args.derived route-derived duration (s), null when there is no route
 * @param {boolean} args.userEdited  the author has explicitly set a duration
 * @returns {string} the value to write into the field (`current` when it must be kept)
 */
export function durationOnEnterDurationMode({ current, derived, userEdited }) {
  if (userEdited) return current
  if (derived == null || !Number.isFinite(derived)) return current
  return derived.toFixed(1) // matches the 1-dp derived-duration display
}
